<template>
    <div v-if="modal.show" class="speaker-modal vue-modal">
        <div class="vue-modal__wrap">
            <div class="popup popup--vue">
                <button class="speaker-modal__close iconlink bg--orange " @click="closeModal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                        <g fill="none" fill-rule="evenodd">
                            <path fill-rule="nonzero" stroke="#FFF" stroke-linecap="round" stroke-width="2" d="M23 37.849L37.849 23" />
                            <path fill-rule="nonzero" stroke="#FFF" stroke-linecap="round" stroke-width="2" d="M23 37.849L37.849 23" transform="matrix(1 0 0 -1 0 60.85)" />
                        </g>
                    </svg>
                </button>
                <div class="p-xl">
                    <div class="speaker-modal__grid mt-lg mb-xl">
                        <div class="speaker-modal__image palm-mb-xl">
                            <img v-if="modalImage" class="image image-round" :src="modalImage" :alt="title">
                        </div>
                        <div class="speaker-modal__details">
                            <h4 class="h4 mb-sm">{{ title }}</h4>
                            <p class="small semi">{{ position }}</p>
                            <p class="small text--grey">{{ organisation }}</p>
                            <a :href="linkedin"
                               target="_blank"
                               class="btn btn--ghost speaker-modal__btn palm-mt-lg"
                            >
                                <svg class="mr-xs" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill="currentColor" d="M1.984 4C3.22 4 4 3.187 4 2.164 3.984 1.133 3.219.336 2.016.336.796.336 0 1.133 0 2.164 0 3.187.781 4 1.96 4h.024zM9 16v-6c0-1.336.852-2 1.852-2s1.812.664 1.812 2.336V16H16v-6c0-3-1.664-4.664-4-4.664-1.336 0-2.336.758-3 1.758l-.11-1.43H5.61c0 .352.054 2.336.054 2.336v8H9zm-5.336 0V5.664H.336V16h3.328z" /></svg>
                                Get in touch
                            </a>
                        </div>
                    </div>
                    <div class="speaker-modal__grid mb-lg">
                        <div class="speaker-modal__sidebar">
                            <div v-if="regionTitle" class="speaker-modal__sidebar-item pb-md palm-pt-md">
                                <h4 class="text--orange semi mb-xs">
                                    State
                                </h4>
                                <p class="semi">
                                    {{ regionTitle }}
                                </p>
                            </div>

                            <div v-if="expertise.length" class="speaker-modal__sidebar-item py-md">
                                <h4 class="text--orange mb-xs semi">
                                    Expertise
                                </h4>
                                <ul class="speaker-modal__sidebar-list semi">
                                    <li v-for="(interest, key) in expertise" :key="key"
                                        class="speaker-modal__sidebar-list-item"
                                    >
                                        {{ interest }}
                                    </li>
                                </ul>
                            </div>

                            <div v-if="otherExpertise" class="speaker-modal__sidebar-item py-md">
                                <h4 class="text--orange mb-xs semi">
                                    Other Expertise
                                </h4>
                                <p class="speaker-modal__sidebar-body semi">
                                    {{ otherExpertise }}
                                </p>
                            </div>
                        </div>
                        <div class="speaker-modal__summary palm-mt-xl" v-html="summary" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modal from '../modal';
    import { EventBus } from '../event-bus';

    export default {
        mixins: [
            modal
        ],

        data() {
            return {

            };
        },
        computed: {
            displayedexpertise() {
                return this.expertise.slice(3);
            },
        },
         mounted() {
            EventBus.$on('speaker-modal', (speakerDetails) => {
                Object.assign(this, speakerDetails);
                
            });
        },
        methods: {
            closeModal() {
                EventBus.$emit('modal-close');
            }
        },
    };
</script>

<style lang="scss" scoped>
    .vue-modal__wrap {
        margin: auto;
    }
</style>